import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { CancelReasonsService } from 'src/app/services/core/cancelReason/cancel-reasons.service';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()

@Component({
  selector: 'app-multi-cancel-modal',
  templateUrl: './multi-cancel-modal.component.html',
  styleUrls: ['./multi-cancel-modal.component.css']
})
export class MultiCancelModalComponent implements OnInit {
 @Input() trips: any = [];
  @Input() preServiceAreas: any;
  companies: any = [];
  @Input() source: any;
  preAppointmentType: any;
  preSpacetypes: any;
  // preMembers: any;
  selectedCompany: any = null;
  selectedTrips:any;
  preCompanies:any = {}
  @Output() closeModal = new EventEmitter<any>();
  status: any;
  cancelReason:any;
  cancelReasons: any = [];
  preLevelOfService:any;
  search:any;
  previousAssignedCompanies:any
  isBillable:boolean = false;
  isNoShow: boolean = false;
  selectedReason: any = null;
  @Output() cancelTripData = new EventEmitter<any>();
  member: any;
  allCancelReasons:any
  noshowReasons:any
  billAbleReasons:any

  constructor(
    private tripService : TripService,
    private companyService: CompanyService,
    private appointmentService: AppointmentTypeService,
    private spaceTypeService:SpaceTypeService,
    private memberService: MemberService,
    private cancelReasonService: CancelReasonsService,
    private router: Router,
    private levelOfService: LosService,
    
  ) {}

  ngOnInit(): void {
    this.status = this.trips && this.trips.length ? this.trips[0].status : '';
    this.cancelReason = this.trips[0].changeReasonNotes
    this.isBillable = this.trips[0].isBillable ? this.trips[0].isBillable : this.trips[0].flags.isBillable
    this.isNoShow = this.trips[0].isNoShow ? this.trips[0].isNoShow : this.trips[0].flags.isNoShow
    if (this.source === 'fundingsourceBilling') {
      this.getMemberById();
    }
    this.selectedTrips = this.trips.map((trip: any) => {
      return trip.id
    })
    this.previousAssignedCompanies = this.trips.map((trip: any) => {
      return {company: trip.company, trip: trip.id}
    });
    this.getPicker()
    this.getAllAppointment();
    // this.getAllMembers();
    this.getSpaceType();
    this.getAllCompanies();
    this.getLevelOfService();
  }

  getMemberById() {
    this.memberService.getMemberById(this.trips[0].member).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data) {
        this.member = data;
      }
    });
  }

  getAllCompanies() {
    this.companyService.getPickerCompanies({limit:9999, isActive : true}).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results ) {
        this.preCompanies = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
      }
    });
  }

  getAllAppointment() {
    this.appointmentService.getPicker({isActive: true, limit: 9999}).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data.results ) {
        this.preAppointmentType = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
      }
    });
  }

  getSpaceType() {
    this.spaceTypeService.getPicker({isActive: true, limit: 9999}).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results ) {
        this.preSpacetypes = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
      }
    });
  }

  getLevelOfService() {
    this.levelOfService.getPicker({isActive: true, limit: 9999}).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results ) {
        this.preLevelOfService = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
      }
    });
  }

  // getAllMembers() {
  //   this.memberService.getMembers({limit:999}).pipe(untilDestroyed(this)).subscribe((data: any) => {
  //     if (data && data.results ) {
  //       this.preMembers = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
  //     }
  //   });
  // }
   getPicker() {
    const queryparam = {
      limit: 999,
      isActive : true
    }
  this.cancelReasonService.picker(queryparam)
    .pipe(untilDestroyed(this))
    .subscribe((data: any) => {
      if (data && data.results) {

        this.allCancelReasons = data.results
        
        this.cancelReasons = data.results.filter((r: any) =>
          r.isBillable === false && r.isNoShow === false
        );
        
        this.billAbleReasons = data.results.filter((r: any) =>
          r.isBillable === true && r.isNoShow === false
        );

        this.noshowReasons = data.results.filter((r: any) =>
          r.isNoShow === true
        );
      }
    });
}


  onCloseModal() {
    this.closeModal.emit();
  }

  cancel() {
    let payload = {}
    if (this.source === 'cancel') {
      payload = {
        pre: this.previousAssignedCompanies,
        selectedIds: this.selectedTrips,
        changeReasonNotes: this.cancelReason,
        status: "cancelled",
        isBillable : this.isBillable,
        isNoShow: this.isNoShow
      };
    } else {
      payload = {
        pre: this.previousAssignedCompanies,
        selectedIds: this.selectedTrips,
        changeReasonNotes: this.cancelReason,
        status: "reroute",
      };
    }
    if(this.source === 'fundingsourceBilling' || this.source === 'billing'){
      this.cancelTripData.emit({ changeReasonNotes: this.cancelReason, isBillable: this.isBillable, isNoShow: this.isNoShow })
      this.onCloseModal();
    }else {
      this.apiRequest(payload);
    }
  }

  apiRequest(payload: any) {
    this.tripService.assignToCompany(payload).pipe(untilDestroyed(this)).subscribe({
      next: (res) => {
        if (res) {
        this.cancelTripData.emit(this.selectedTrips)
         this.onCloseModal();
        }
      }
    })
  }
setReason(reasonTitle: string) {
  // Find the reason object from cancelReasons
  const reasonObj = this.allCancelReasons.find((r:any) => r.title === reasonTitle);
  if (reasonObj) {
    this.selectedReason = reasonObj;    
    this.cancelReason = reasonObj.title;
    this.isBillable = !!reasonObj.isBillable;
    this.isNoShow = !!reasonObj.isNoShow;

  } else {
    this.selectedReason = null;
    this.isBillable = false;
    this.isNoShow = false;
  }
}

onCustomReasonChange(value: string) {
  this.cancelReason = value;
  this.selectedReason = null;
  this.isBillable = false;
  this.isNoShow = false;
}
}

